import React from "react";
import styled from "styled-components";
import blogPost1 from "../images/home/blogPost1.webp";
import blogPost2 from "../images/home/blogPost2.webp";
import blogPost3 from "../images/home/blogPost3.webp";

const BlogSection = () => {
  const blogs = [
    {
      id: 1,
      title: "25 Stocking Stuffer Ideas for...",
      date: "NOVEMBER 6, 2025",
      description:
        "Discover 25 fun and unique stocking stuffer ideas for Christmas that will delight everyone on your list. Get inspired and make this holiday season special!",
      image: blogPost1,
      url: "#",
    },
    {
      id: 2,
      title: "How to Throw a Meaningful...",
      date: "OCTOBER 30, 2025",
      description:
        "Thanksgiving isn’t just about the food — it’s about connection, gratitude, and creating memories that linger long after the last slice of pie.",
      image: blogPost2,
      url: "#",
    },
    {
      id: 3,
      title: "Discover Fun Ways to...",
      date: "SEPTEMBER 16, 2025",
      description:
        "Transform your Bible into a cherished keepsake with fun personalization ideas. Discover how to make your spiritual journey truly your own.",
      image: blogPost3,
      url: "#",
    },
  ];

  return (
    <Section>
      <Heading>Blog Posts</Heading>

      <Grid>
        {blogs.map((blog) => (
          <Card key={blog.id}>
            <ImageWrapper>
              <img src={blog.image} alt={blog.title} />
            </ImageWrapper>

            <Content>
              <BlogTitle href={blog.url}>{blog.title}</BlogTitle>
              <Date>{blog.date}</Date>
              <Description>{blog.description}</Description>
            </Content>
          </Card>
        ))}
      </Grid>

      <ButtonWrapper>
        <ViewAllBtn>View all</ViewAllBtn>
      </ButtonWrapper>
    </Section>
  );
};

export default BlogSection;

const Section = styled.section`
  width: 100%;
  padding: 60px 0;
  background: #fff;
`;

const Heading = styled.h2`
  text-align: center;
  font-size: 32px;
  color: #244c48;
  margin-bottom: 40px;
`;

const Grid = styled.div`
  width: 85%;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);
  }
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 220px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Content = styled.div`
  padding: 20px;
`;

const BlogTitle = styled.a`
  display: block;
  font-size: 26px;
  color: #244c48;
  font-weight: 600;
  text-decoration: none;
  margin-bottom: 10px;

  &:hover {
    color: #1f3e3a;
  }
`;

const Date = styled.div`
  font-size: 14px;
  letter-spacing: 1px;
  margin-bottom: 14px;
  color: #555;
`;

const Description = styled.p`
  color: #333;
  font-size: 18px;
  line-height: 1.5;
`;

const ButtonWrapper = styled.div`
  text-align: center;
  margin-top: 40px;
`;

const ViewAllBtn = styled.button`
  padding: 14px 40px;
  background: #3b4b48;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 18px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    opacity: 0.85;
  }
`;
